/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum tagTargetTypeEnum {
    USER = 'user',
    PLAN = 'plan',
    POOL = 'pool',
    QUERY = 'query',
    OTHER = 'other',
}